




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MenuItem } from "shared/bootstrap";
import { namespace } from "vuex-class";

const authStore = namespace("auth");

@Component
export default class MainMenu extends Vue {
  @authStore.Getter("loggedIn") loggedIn!: boolean;

  @Prop({ required: true })
  items!: MenuItem[];

  @Prop({ default: false })
  topDivider!: boolean;

  seperatedItems: MenuItem[][] = [];

  @Watch("loggedIn", { immediate: true })
  private async onLoggedIn(p: boolean) {
    const filtered: MenuItem[] = [];
    for (const item of this.items) {
      if (item.asyncShow && !(await item.asyncShow())) continue;
      if (p) {
        if (!item.hideAuth) filtered.push(item);
      } else {
        if (!item.hideNoAuth) filtered.push(item);
      }
    }

    this.seperatedItems = [
      filtered.filter((item) => item.top),
      filtered.filter((item) => !item.top && !item.bottom),
      filtered.filter((item) => item.bottom),
    ];
  }

  deviderNeeded(i: number): boolean {
    return (
      this.seperatedItems[i].length > 0 &&
      i > 0 &&
      this.seperatedItems[i - 1].length > 0
    );
  }
}
